import {MapDifficultyLevel, NORTH_AMERICA_COUNTRIES} from "../types";

// function print() {
//   const codes: string[] = []
//   for (const name of [
// "Bahamas","Barbados","Belize","Canada","Costa Rica","Cuba","Dominican Republic","El Salvador","Greenland","Guatemala","Haiti","Honduras","Jamaica","Mexico","Nicaragua","Panama","Trinidad and Tobago","United States of America",
//   ]) {
//     console.log(name);
//     const country = ALL_COUNTRIES.find(c => c.name === name);
//     codes.push(`$CC("${country.cc}")`);
//   }
//   console.log(codes.join(", "));
// }
// print();
export class NorthAmericaDifficultyLevel extends MapDifficultyLevel {

  static readonly VALUES = new Array<NorthAmericaDifficultyLevel>(1);
  static readonly MEDIUM = NorthAmericaDifficultyLevel.VALUES[0] = new NorthAmericaDifficultyLevel("medium", "Medium", "Medium desc", NORTH_AMERICA_COUNTRIES);
}